module.exports = __webpack_public_path__ + "static/garmin-7eb4991a9d378febf5cafe67234b99b9.svg";